import { NodoDto } from "@/api";
import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

type InfoItemProps = {
  label: string;
  value: string;
};

function InfoItem({ label, value }: InfoItemProps) {
  return (
    <Box>
      <Typography variant="caption">{label}</Typography>
      <Typography variant="h4">{value}</Typography>
    </Box>
  );
}

const contaore: { label: string; parziale: string; totale: string }[] = [
  {
    label: "motopompa P1",
    parziale: "ctorep1p",
    totale: "ctorep1t",
  },
  {
    label: "pompa vuoto PV1",
    parziale: "ctorepv1p",
    totale: "ctorepv1t",
  },
  {
    label: "resistenza RH1",
    parziale: "ctorerh1p",
    totale: "ctorerh1t",
  },
  {
    label: "resistenza RH2",
    parziale: "ctorerh2p",
    totale: "ctorerh2t",
  },
];

export function GFL_TFLD_550_2_Info({ nodo }: { nodo: NodoDto }) {
  const { t } = useTranslation();
  const info = nodo.dispositivoLastInfo ?? {};

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Grid container spacing={2}>
        {contaore.map(({ label, parziale, totale }) => (
          <Grid item xs={12} container spacing={2} key={parziale}>
            <Grid item xs={12} md={6}>
              <InfoItem
                label={`Contaore ${label} parziale`}
                value={info[parziale] ?? t("valori.nd")}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InfoItem
                label={`Contaore ${label} totale`}
                value={info[totale] ?? t("valori.nd")}
              />
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
